import reservationsApi from '#app/api/reservations'
import preq from '#app/lib/preq'
import type { Reservation } from '#server/types/reservation'
import { getUsersByIds } from '#users/users_data'

export async function getItemReservations (itemId) {
  const reservations = await getItemReservationQueue(itemId)
  const requesterIds = [ ...new Set(reservations.map(reservation => reservation.requester)) ]
  const usersById = await getUsersByIds(requesterIds)
  return reservations.map(reservation => ({
    ...reservation,
    requesterUser: usersById[reservation.requester],
  }))
}

export async function getItemReservationQueue (itemId) {
  const { reservations } = await preq.get(reservationsApi.byItem(itemId)) as { reservations: Reservation[] }
  return reservations
}

export async function createItemReservation ({ item, group, month, message }) {
  const { reservation } = await preq.post(reservationsApi.create, {
    item,
    group: group || undefined,
    month,
    message: message?.trim() || undefined,
  })
  return reservation
}

export async function returnBorrowedBook (transaction) {
  const { transaction: updated } = await preq.post(reservationsApi.returnBorrowed, { transaction })
  return updated
}

export async function confirmBorrowedBook (transaction) {
  const { transaction: updated } = await preq.post(reservationsApi.confirmBorrowed, { transaction })
  return updated
}

export async function getMyReservations () {
  const { reservations } = await preq.get(reservationsApi.mine)
  return reservations
}

export async function getBorrowingOverview (userId?: string) {
  return preq.get(userId ? reservationsApi.byUser(userId) : reservationsApi.mine)
}

export async function getCurrentBorrowedBooks () {
  const { borrowedBooks } = await preq.get(reservationsApi.currentBorrowed)
  return borrowedBooks
}

export async function getFutureReservations () {
  return preq.get(reservationsApi.future)
}

export async function getBorrowingHistory () {
  const { transactions } = await preq.get(reservationsApi.history)
  return transactions
}

export async function updateReservationState ({ reservation, state }) {
  const { reservation: updated } = await preq.put(reservationsApi.updateState, { reservation, state })
  return updated
}

export async function adminCancelReservation (reservation) {
  const { reservation: updated } = await preq.put(reservationsApi.adminCancel, { reservation })
  return updated
}

export function nextReservationMonths (count = 12) {
  const now = new Date()
  const months = []
  for (let i = 0; i < count; i++) {
    const date = new Date(now.getFullYear(), now.getMonth() + i, 1)
    months.push(`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`)
  }
  return months
}

export function getActiveReservations (reservations) {
  return reservations
  .filter(reservation => [ 'reserved', 'handed_over' ].includes(reservation.state))
  .sort((a, b) => a.month.localeCompare(b.month) || a.created - b.created)
}

export function reservationMonthHasStarted (month, now = new Date()) {
  const currentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
  return month <= currentMonth
}

export function formatReservationStartDate (month) {
  const [ year, monthNumber ] = month.split('-').map(Number)
  const monthName = new Intl.DateTimeFormat('fr-FR', { month: 'long', year: 'numeric' })
    .format(new Date(year, monthNumber - 1, 1))
  return `1er ${monthName}`
}
